module.exports = __webpack_public_path__ + "media/images/child-stock-004ca47b.jpg";